<template>
  <div class="vaults-stats">
    <div class="text-4">DeFi Stats</div>
    <div class="mt-6">
      <vaults-table :vaultItems="vaultItems" class="d-none d-md-block" />
      <vault-list-mobile :vaultItems="vaultItems" class="d-block d-md-none" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import { projectMapEco } from "@/common/config/ecosystems";
import VaultsTable from "./VaultsTable.vue";
import VaultListMobile from "./VaultListMobile.vue";

export default {
  components: {
    VaultsTable,
    VaultListMobile,
  },
  computed: {
    ...mapGetters({
      getVaultByTypeAndToken: "projectConfig/getVaultByTypeAndToken",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      vaultsStats: "productStats/vaultsStats",
      apys: "productStats/apys",
    }),
    displayedStats() {
      if (!this.vaultsStats.result) return [];
      return this.vaultsStats.result
        .map(item => {
          const vault = this.getVaultByTypeAndToken({
            type: item.vaultType,
            token: item.token,
          });
          if (!vault) return null;
          return {
            identity: vault.identity,
            vaultText: vault.vaultText,
            tokenText: vault.text,
            ...item,
          };
        })
        .filter(item => !!item);
    },
    vaultItems() {
      const data = [];
      this.displayedStats.forEach(item => {
        const tokenLowercased = item.token.toLowerCase();
        const tokenPrice = this.getTokenPriceInUsd(tokenLowercased);
        const apyDetails3Days =
          this.apys.vaults[item.vaultType]?.[tokenLowercased].details.find(
            item => item.days === 3
          ) || {};
        const apyDetails15Days =
          this.apys.vaults[item.vaultType]?.[tokenLowercased].details.find(
            item => item.days === 15
          ) || {};
        data.push({
          identity: item.identity,
          type: item.vaultType,
          name: item.vaultText,
          token: item.token,
          tokenName: item.tokenText,
          tokenPrice: tokenPrice,
          vaultBalance: new BN(tokenPrice)
            .multipliedBy(item.balanceInVault)
            .toNumber(),
          strategyBalance: new BN(tokenPrice)
            .multipliedBy(item.balanceInStrategy)
            .toNumber(),
          totalValueLocked: new BN(tokenPrice)
            .multipliedBy(item.expectedReturn)
            .toNumber(),
          balanceChange24h: {
            totalValueLocked: {
              value: new BN(item.tvlAfter)
                .minus(item.tvlBefore)
                .multipliedBy(tokenPrice)
                .toNumber(),
              percentage: new BN(item.percentChanged)
                .multipliedBy(100)
                .toNumber(),
            },
          },
          yield3Days: {
            apy: new BN(apyDetails3Days.apy).multipliedBy(100).toNumber(),
            ROI: new BN(apyDetails3Days.roi).multipliedBy(100).toNumber(),
            feesROI: new BN(apyDetails3Days.feeROI)
              .multipliedBy(100)
              .toNumber(),
            harvestROI: new BN(apyDetails3Days.harvestROI)
              .multipliedBy(100)
              .toNumber(),
            bonus: new BN(apyDetails3Days.slippage)
              .multipliedBy(100)
              .toNumber(),
          },
          yield15Days: {
            apy: new BN(apyDetails15Days.apy).multipliedBy(100).toNumber(),
            ROI: new BN(apyDetails15Days.roi).multipliedBy(100).toNumber(),
            feesROI: new BN(apyDetails15Days.feeROI)
              .multipliedBy(100)
              .toNumber(),
            harvestROI: new BN(apyDetails15Days.harvestROI)
              .multipliedBy(100)
              .toNumber(),
            bonus: new BN(apyDetails15Days.slippage)
              .multipliedBy(100)
              .toNumber(),
          },
          market: projectMapEco.ethereum,
        });
      });
      return data;
    },
  },
  mounted() {
    this.$store.dispatch("productStats/fetchVaultsStats");
  },
};
</script>
